/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-07-22 20:24:57
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-27 14:58:21
 * @Description:
 * @FilePath: /src/store/modules/common.js
 */
import {
    QZ_PLATFORM_ID,
    QZ_SUB_PLATFORM_ID,
    QZ_CURRENT_SCENE,
    QZ_SCENE_TYPE,
    QZ_CURRENT_SCENE_VALUE,
    QZ_MERCH_ID,
    QZ_PROMOTER_ID,
} from 'constant';
import util from 'util';
import store from '@/store';
const common = {
    state: {
        // 初始化状态
        initialization: false,
        // 微信config注册时域名
        wxConfigHref: '',
        env: '',
        config: null,
        // 渠道配置加载失败时展示错误页，避免删除 Vue 根节点造成白屏
        configError: null,
        pageLoadError: false,
        title: {
            status: false,
            systemHeight: '0px',
            titleHeight: '0px',
            titleName: '',
        },
        isReloadApp: false,
        platformId: null,
        subPlatformId: null,
        merchId: '',
        promoterId: '',
        currentScene: 0,
        message: null,
        bodyCssText: '',
        orderId: null,
        closeWindowType: 0,
        // 微信支付的配置信息
        wechatPay: {
            status: false,
            allowDomains: [],
            redirectDomain: '',
        },
    },
    mutations: {
        setPageLoadError(state, data) {
            state.pageLoadError = data;
        },
        setInitialization(state, data) {
            state.initialization = data;
        },
        setWxConfigHref(state, data) {
            if (state.wxConfigHref == '') {
                state.wxConfigHref = data;
            }
        },
        setEnv(state, data) {
            state.env = data;
        },
        setConfig(state, data) {
            state.config = data;
        },
        setConfigError(state, data) {
            state.configError = data;
        },
        reloadApp(state) {
            state.isReloadApp = true;
        },
        startApp(state) {
            state.isReloadApp = false;
        },
        setPlatformId(state, data) {
            state.platformId = data;
            localStorage.setItem(QZ_PLATFORM_ID, data);
        },
        setSubPlatformId(state, data) {
            state.subPlatformId = data;
            localStorage.setItem(QZ_SUB_PLATFORM_ID, data);
        },
        setSceneType(state, data) {
            state.sceneType = data;
            window.localStorage.setItem(QZ_SCENE_TYPE, data);
        },
        setCurrentScene(state, data) {
            if (state.currentScene == QZ_CURRENT_SCENE.APP_MG && data == QZ_CURRENT_SCENE.APP) {
                data = QZ_CURRENT_SCENE.APP_MG;
            }
            state.currentScene = data;
            window.localStorage.setItem(QZ_CURRENT_SCENE_VALUE, data);
        },
        setTitleStatus(state, data) {
            state.title.status = data;
        },
        setSystemHeight(state, data) {
            state.title.systemHeight = data;
        },
        setTitleHeight(state, data) {
            state.title.titleHeight = data;
        },
        setTitleName(state, data) {
            state.title.titleName = data;
        },
        clearTitleName(state) {
            state.title.titleName = '';
        },
        setMessage(state, data) {
            state.message = data;
        },
        clearMessage(state) {
            state.message = null;
        },
        setBodyCssText(state, data) {
            state.bodyCssText = data;
        },
        setOrderId(state, data) {
            state.orderId = data;
        },
        clearOrderId(state) {
            state.orderId = null;
        },
        setCloseWindowType(state, data) {
            state.closeWindowType = data;
        },
        setWechatPayStatus(state, data) {
            state.wechatPay.status = data;
        },
        setWechatPayAllowDomains(state, data) {
            state.wechatPay.allowDomains = data;
        },
        setWechatPayRedirectDomain(state, data) {
            state.wechatPay.redirectDomain = data;
        },
        setMerchId(state, data) {
            state.merchId = data;
            localStorage.setItem(QZ_MERCH_ID, data);
        },
        setPromoterId(state, data) {
            state.promoterId = data;
            localStorage.setItem(QZ_PROMOTER_ID, data);
        },
    },
    getters: {
        platformId: state => {
            return state.platformId;
        },
        getExposeMethod: state => {
            return getExposeMethodNext(state, state.currentScene);
        },
        initialization: state => {
            return state.initialization;
        },
        platformConfig: state => {
            return state.config;
        },
        isApp: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.APP, state.currentScene);
        },
        isWechatMin: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.WX_MIN, state.currentScene);
        },
        isWechatBrowser: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.WX_BROWSER, state.currentScene);
        },
        isTTMin: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.TT_MIN, state.currentScene);
        },
        isAlipayBrowser: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.ALIPAY_BROWSER, state.currentScene);
        },
        isAlipayMin: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.ALIPAY_MIN, state.currentScene);
        },
        isBDMin: state => {
            return JudgeTheEnvironment(QZ_CURRENT_SCENE.BD_MIN, state.currentScene);
        },
    },
    actions: {
        setCurrentScene: ({ commit, state }, currentScene) => {
            return new Promise((resole, reject) => {
                store.commit('setSceneType', 1);
                store.commit('setCurrentScene', currentScene);
                return resole({
                    success: true,
                    data: {
                        currentScene,
                    },
                });
            });
        },
        wechatPay: ({ commit, state }) => {
            return new Promise((resolve, reject) => {
                if (state.wechatPay.status) {
                    return resolve(state.wechatPay);
                }
                // 如果 config 已经加载，直接使用已有数据，避免重复请求
                if (state.config) {
                    commit('setWechatPayStatus', true);
                    commit('setWechatPayAllowDomains', state.config.wechatPayAllowDomains);
                    commit('setWechatPayRedirectDomain', state.config.wechatPayRedirectDomain);
                    return resolve(state.wechatPay);
                }
                // config 未加载时，调用 getPlatformInfo 获取数据
                util.getPlatformInfo(state.platformId).then(res => {
                    if (res.success) {
                        commit('setWechatPayStatus', true);
                    }
                    return resolve(state.wechatPay);
                });
            });
        },
        getExposeMethod: ({ commit, state }) => {
            return new Promise((resolve, reject) => {
                if (state.currentScene == 0) {
                    util.setCurrentScene().then(res => {
                        if (res.success) {
                            return resolve(getExposeMethodNext(state, res.currentScene));
                        }
                    });
                } else {
                    return resolve(getExposeMethodNext(state, state.currentScene));
                }
            });
        },
    },
};

function getExposeMethodNext(state, currentScene) {
    let configName = '';
    if (JudgeTheEnvironment(QZ_CURRENT_SCENE.APP, currentScene)) {
        configName = 'app';
    } else if (JudgeTheEnvironment(QZ_CURRENT_SCENE.WX_MIN, currentScene)) {
        configName = 'wechat_miniapp';
    } else if (JudgeTheEnvironment(QZ_CURRENT_SCENE.WX_BROWSER, currentScene)) {
        configName = 'wechat_h5';
    } else if (JudgeTheEnvironment(QZ_CURRENT_SCENE.BD_MIN, currentScene)) {
        configName = 'wechat_miniapp';
    } else if (JudgeTheEnvironment(QZ_CURRENT_SCENE.ALIPAY_MIN, currentScene)) {
        configName = 'wechat_miniapp';
    }

    if (configName == '') {
        return {};
    }
    if (state.config && state.config[configName] && state.config[configName].exposeMethodName) {
        return JSON.parse(state.config[configName].exposeMethodName);
    } else {
        return {};
    }
}
function JudgeTheEnvironment(standardScene, currentScene) {
    if (currentScene >= standardScene && currentScene < standardScene + QZ_CURRENT_SCENE.STEP) {
        return true;
    }
    return false;
}

export default common;
